import { DBConfig } from 'ngx-indexed-db';

export const indexedDBConfig: DBConfig = {
  name: 'FileUploadDB',
  version: 1, // Incremented version number for the schema change
  objectStoresMeta: [
    {
      store: 'jobs',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        { name: 'userId', keypath: 'userId', options: { unique: false } },
        { name: 'status', keypath: 'status', options: { unique: false } },
        { name: 'createdAt', keypath: 'createdAt', options: { unique: false } },
        { name: 'retries', keypath: 'retries', options: { unique: false } },
        { name: 'files', keypath: 'files', options: { unique: false } },
        { name: 'completion', keypath: 'completion', options: { unique: false } },
        { name: 'uploadedFiles', keypath: 'uploadedFiles', options: { unique: false } },
        { name: 'lastModified', keypath: 'lastModified', options: { unique: false } },
      ] 
    }
  ]
};
